import { useState } from "react";
import emailjs from "@emailjs/browser";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    surname: "",
    email: "",
    phone: "",
    eventType: "",
    eventDate: "",
    dayGuests: "",
    eveningGuests: "",
    partySize: "",
    notes: "",
  });

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const formatDateLong = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const weekday = date.toLocaleDateString("en-GB", { weekday: "long" });
    const month = date.toLocaleDateString("en-GB", { month: "long" });
    const year = date.getFullYear();

    // Suffix logic
    const getOrdinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`;

    return `${weekday} ${dayWithSuffix} ${month} ${year}`;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formattedData = {
        ...formData,
        eventDate: formatDateLong(formData.eventDate),
      };
      await emailjs.send(
        "service_jpa0gqo",
        "template_khzm13e",
        formattedData,
        "Hvu_XVUVW0O-QPUEW"
      );
      setMessage("Your request has been sent successfully!");
      setFormData({
        firstName: "",
        surname: "",
        email: "",
        phone: "",
        eventType: "",
        eventDate: "",
        dayGuests: "",
        eveningGuests: "",
        partySize: "",
        notes: "",
      });
    } catch (error) {
      setMessage("Oops! Something went wrong, please try again.");
    } finally {
      setLoading(false);
    }
  };

  const isFormEnabled = formData.eventType !== "";

  return (
    <div id="ContactForm" className="max-w-2xl mx-auto bg-white p-6 shadow-lg rounded-xl mb-16">
      <h2 className="text-2xl font-bold mb-4 text-center">Contact Us</h2>
      {message && <p className="text-center text-green-600">{message}</p>}
      <form onSubmit={handleSubmit} className="space-y-4">
      <select
        name="eventType"
        value={formData.eventType}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full"
      >
        <option value="">Select Event Type</option>
        <option value="Wedding">Wedding</option>
        <option value="Christmas Party">Christmas Party</option>
        <option value="Special Occasion">Special Occasion</option>
        <option value="Charity Event">Charity Event</option>
        <option value="Celebration of Life">Celebration of Life</option>
      </select>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input
          type="text"
          name="firstName"
          placeholder="First Name"
          value={formData.firstName}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full"
          disabled={!formData.eventType}
        />
        <input
          type="text"
          name="surname"
          placeholder="Surname"
          value={formData.surname}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full"
          disabled={!formData.eventType}
        />
      </div>

      <input
        type="email"
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full"
        disabled={!formData.eventType}
      />
      <input
        type="tel"
        name="phone"
        placeholder="Phone Number"
        value={formData.phone}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full"
        disabled={!formData.eventType}
      />
      <input
        type="date"
        name="eventDate"
        value={formData.eventDate}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full"
        disabled={!formData.eventType}
      />

      {formData.eventType === "Wedding" && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <input
            type="number"
            name="dayGuests"
            placeholder="Number of Day Guests"
            value={formData.dayGuests}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full"
          />
          <input
            type="number"
            name="eveningGuests"
            placeholder="Number of Evening Guests"
            value={formData.eveningGuests}
            onChange={handleChange}
            required
            className="border p-2 rounded w-full"
          />
        </div>
      )}

      {isFormEnabled && formData.eventType !== "Wedding" && (
        <input
          type="number"
          name="partySize"
          placeholder="Party Size"
          value={formData.partySize}
          onChange={handleChange}
          className="border p-2 rounded w-full"
        />
      )}

      <textarea
        name="notes"
        placeholder="Additional Notes"
        value={formData.notes}
        onChange={handleChange}
        className="border p-2 rounded w-full h-28"
        disabled={!formData.eventType}
      />

        <button
          type="submit"
          className={`w-full px-6 py-2 rounded-full text-white transition duration-300 shadow-md cursor-pointer ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gray-700 hover:bg-gray-800"
          }`}
          disabled={!formData.eventType || loading}
        >
          {loading ? "Sending..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
